import React from 'react'

import { Container, Grid } from '@toptal/picasso'
import TextArea, { ChangeEventType } from '../TextArea'

import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { inputChanged } from '../../actions'
import { IStoreState } from '../../utils'
import texts from '../../texts.json'

interface IProps {
  first?: string
  second?: string
  third?: string
  onInputChange(event: ChangeEventType): void
}

// define grid sizes at different breakpoints
const SMALL = 12
const MEDIUM = 4

export const MergeInputs: React.FunctionComponent<IProps> = ({
  first = '',
  second = '',
  third = '',
  onInputChange
}) => {
  return (
    <Container>
      <Grid>
        <Grid.Item small={SMALL} medium={MEDIUM}>
          <TextArea
            value={first}
            name='first'
            onChange={onInputChange}
            label={texts.mergeInputLabel}
          />
        </Grid.Item>
        <Grid.Item small={SMALL} medium={MEDIUM}>
          <TextArea
            value={second}
            name='second'
            onChange={onInputChange}
            label={texts.mergeInputLabel}
          />
        </Grid.Item>
        <Grid.Item small={SMALL} medium={MEDIUM}>
          <TextArea
            value={third}
            name='third'
            onChange={onInputChange}
            label={texts.mergeInputLabel}
          />
        </Grid.Item>
      </Grid>
    </Container>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  first: state.first,
  second: state.second,
  third: state.third
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onInputChange: (event: ChangeEventType) => {
    const { target } = event
    dispatch(inputChanged(target.name, target.value))
  }
})

const MergeWordsSmart = connect(
  mapStateToProps,
  mapDispatchToProps
)(MergeInputs)

export default MergeWordsSmart
